import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import ReceiveTopSection from './ReceiveTopSection'
import { ReceiveMiddleSection } from './ReceiveMiddleSection'
import ReceiveBottomSection from './ReceiveBottomSection'
import CommonTable from '../../common/CommonTable'
import { clickElement } from '../../common/helper'
import Dashboard from '../../common/DashBoard'
import { JAIN_NEW } from '../../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { receiveLITLrListAtom, showListAllAtom } from '../../common/jotaiState/receiveStateAtoms'
import { alertAtom } from '../../common/jotaiState/globalStateAtoms'
import { getDashBoardData } from '../../../store/common/common_action'
import useToken from '../../helpers/useTokens'

const BranchTransferReceive = ({ data, getDashBoardData}) => {
  const { common } = data
  const { loginData } = useToken()
  const [, setAlert] = useAtom(alertAtom)
  const handleAlert = (msg = false) => {
    if (!(msg instanceof Event)) {
      if (msg) {
        setAlert({ show: true, msg })
      } else {
        setAlert({ show: false, msg: '' })
      }
    }
  }
  const { cnsgnmntTypes, ReceiveDashboard } = common
  const { intCompanyID } = loginData
  const [selectedVehicleData, setSelectedVehicleData] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [dashboardOpen, setDashboardOpen] = useState(true)
  const [resetFlag,setResetFlag]=useState(false)
  const [, setShowListAll] = useAtom(showListAllAtom)
  const [state, setState] = useState({
    showListTable: false,
  })
  const [receiveLITLrList] = useAtom(receiveLITLrListAtom)

  const { showListTable } = state

  const [topSelectedData, setTopSelectedData] = useState({
    DFromCity: null,
    DFromBranch: null,
    consignmentData: null,
    SelectedVehicle: '',
    resetData: false,
    LRNO: '',
  })
  const [showBtnList, setShowBtnList] = useState(true)
  const [tSecDropData, setTSecDropData] = useState({
    selectconsignmentType: 'All',
    SellectedChallanNumber: null,
  })

  useEffect(() => {
    if (topSelectedData.DFromBranch !== null) {
      clickElement('firstGoButtonReceive')
    }
  }, [topSelectedData.DFromBranch])
  useEffect(() => {
    setState({
      ...state,
      showListTable: false,
    })
    setShowListAll(false)
    setSelectedData([])
    setTopSelectedData({
      ...topSelectedData,
      LRNO: '',
    })
  }, [topSelectedData.DFromBranch])
  useEffect(() => {
    setTopSelectedData({ ...topSelectedData, consignmentData: cnsgnmntTypes })
  }, [])
  useEffect(() => {
    if (topSelectedData.DFromCity !== null) {
      if (topSelectedData.DFromBranch !== null) {
        setTopSelectedData({ ...topSelectedData, DFromBranch: null })
        clickElement('BranchReceiveFromBranch')
      }
    }
  }, [topSelectedData.DFromCity])
  useEffect(() => {
    if (topSelectedData.DFromBranch !== null) {
      if (topSelectedData.SelectedVehicle !== '') {
        setTopSelectedData({ ...topSelectedData, SelectedVehicle: '' })
        clickElement('BranchreceiveVehicleCross')
      }
    }
  }, [topSelectedData.DFromBranch])
  useEffect(()=>{
    if(intCompanyID){
      getDashBoardData(loginData, 'R')
    }
  },[intCompanyID])
  return (
    <>
      <ReceiveTopSection
        setResetFlag={setResetFlag}
        resetFlag={resetFlag}
        setState={setState}
        state={state}
        topSelectedData={topSelectedData}
        setTopSelectedData={setTopSelectedData}
        tSecDropData={tSecDropData}
        setTSecDropData={setTSecDropData}
        setSelectedData={setSelectedData}
        setShowBtnList={setShowBtnList}
        showBtnList={showBtnList}
        selectedVehicleData={selectedVehicleData}
        setSelectedVehicleData={setSelectedVehicleData}
        handleAlert={handleAlert}
        setDashboardOpen={setDashboardOpen}
      />
      {dashboardOpen && showListTable === false && intCompanyID !== JAIN_NEW && !receiveLITLrList?.length ? (
        <Dashboard setDashboardOpen={setDashboardOpen} DashboardData={ReceiveDashboard} Type="Receive" handleAlert={handleAlert} />
      ) : (
        ''
      )}
      {receiveLITLrList?.length > 0 ? (
        <CommonTable
          tableData={receiveLITLrList}
          selelectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      ) : (
        ''
      )}

      {showListTable && !receiveLITLrList?.length ? (
        <ReceiveMiddleSection
          selelectedData={selectedData}
          setSelectedData={setSelectedData}
          topSelectedData={topSelectedData}
          tSecDropData={tSecDropData}
        />
      ) : (
        ''
      )}
      <ReceiveBottomSection
        setResetFlag={setResetFlag}
        resetFlag={resetFlag}
        topSelectedData={topSelectedData}
        tSecDropData={tSecDropData}
        selectedData={selectedData}
        setTSecDropData={setTSecDropData}
        indexSetState={setState}
        setTopSelectedData={setTopSelectedData}
        setSelectedData={setSelectedData}
        setShowBtnList={setShowBtnList}
        setSelectedVehicleData={setSelectedVehicleData}
        handleAlert={handleAlert}
        selelectedData={selectedData}
      />
    </>
  )
}

export default connect((data) => ({ data }), { getDashBoardData })(BranchTransferReceive)
